import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@lightspeed/flame/Modal';

export const StyledModal = styled(Modal)`
  max-width: 50%;
  @media screen and (max-width: 992px) {
    max-width: 80%;
  }
  @media screen and (max-width: 768px) {
    min-width: 70%;
    max-width: 80%;
  }
`;

export const StyledModalHeader = styled(ModalHeader)`
  max-width: 100%;
  justify-content: space-between;
  > * {
    max-width: 90%;
  }
`;

export const StyledModalBody = styled(ModalBody)`
  padding: 0px !important;
  overflow-y: auto;
  margin-bottom: -1px;
  position: relative;
`;

export const StyledModalFooter = styled(ModalFooter)`
  z-index: 1;
`;

export const StyledItemDescription = styled(Box)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const StyledItemIdWidth = styled(Box)`
  width: 35%;
`;

export const StyledItemDescriptionWidth = styled(Box)`
  width: 45%;
`;

export const StyledDateTimeWidth = styled(Box)`
  width: 20%;
`;

export const StyledConfirmClose = styled(Box)`
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

export const StyledConfirmCloseContent = styled(Box)`
  text-align: center;
`;
